const route = () => '/reports/security';

export default route;
